/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "style"];
import "./styled.compiled.css";
import { forwardRef } from 'react';
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { IconTitleWrapperOldVisualRefresh } from '../IconAndTitleLayout/styled';

// TODO Delete when cleaning platform-linking-visual-refresh-v1
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var SpinnerWrapperOldVisualRefresh = forwardRef(function (_ref, __cmplr) {
  var _ref$as = _ref.as,
    C = _ref$as === void 0 ? IconTitleWrapperOldVisualRefresh : _ref$as,
    __cmpls = _ref.style,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _s7n41ndm", __cmplp.className])
  }));
});
if (process.env.NODE_ENV !== 'production') {
  SpinnerWrapperOldVisualRefresh.displayName = 'SpinnerWrapperOldVisualRefresh';
}